<template>
  <div v-if="needRefresh && !appStore.isAuthenticating" class="toast toast-start toast-top sm:toast-bottom z-50">
    <div class="alert alert-info shadow-lg gap-2">
      <span>A new version is available.</span>
      <div class="flex gap-2">
        <button class="btn btn-sm btn-ghost" @click="dismiss">Later</button>
        <button class="btn btn-sm btn-primary" @click="handleUpdate">Update now</button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useRegisterSW } from 'virtual:pwa-register/vue';
import { FiveMinutesInMilliseconds } from '@/constants';
import { useApplicationStore } from '@/stores/Application';

// tmi-6gh T3: hide the update banner while a sign-in / token handoff is fetching user +
// permissions, so a mid-auth reload cannot leave the user in an authenticated-but-freemium state.
const appStore = useApplicationStore();

const { needRefresh, updateServiceWorker } = useRegisterSW( {
    immediate: true,
    onRegisteredSW( _swUrl, registration ) {
        if ( !registration ) return;

        setInterval( async () => {
            if ( !( !registration.installing && navigator ) ) return;
            if ( 'connection' in navigator && !navigator.onLine ) return;

            await registration.update();
        }, FiveMinutesInMilliseconds );
    },
} );

function dismiss() {
    needRefresh.value = false;
}

async function handleUpdate() {
    navigator.serviceWorker.addEventListener( 'controllerchange', () => {
        window.location.reload();
    } );
    await updateServiceWorker( true );
}
</script>
